import apiClient from "./axios"

// Get units list
export const getUnitList = async (params = {}) => {
  const { data } = await apiClient.get("/units", { params })
  return data
}

// Get single unit by ID
export const getUnitById = async id => {
  const { data } = await apiClient.get(`/units/${id}`)
  return data
}

// Create unit
export const createUnit = async payload => {
  const { data } = await apiClient.post("/units", payload)
  return data
}

// Update unit
export const updateUnit = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/units/${id}`, payload)
  return data
}

// Soft delete unit
export const deleteUnit = async id => {
  const { data } = await apiClient.delete(`/units/${id}`)
  return data
}

// Get trashed units
export const getTrashedUnits = async (params = {}) => {
  const { data } = await apiClient.get("/units/trashed", { params })
  return data
}

// Get unit by slug
export const getUnitBySlug = async slug => {
  const { data } = await apiClient.get(`/units/slug/${slug}`)
  return data
}

// Restore unit
export const restoreUnit = async id => {
  const { data } = await apiClient.post(`/units/${id}/restore`)
  return data
}

// Permanently delete unit
export const forceDeleteUnit = async id => {
  const { data } = await apiClient.delete(`/units/${id}/force-delete`)
  return data
}
